import { Option, None } from "@siteimprove/alfa-option";
import { Rule } from "./rule.js";
/**
 * @public
 */
export class Sheet {
    static of(rules, disabled = false, condition = None) {
        return new Sheet(Array.from(rules), disabled, condition);
    }
    static empty() {
        return new Sheet([], false, None);
    }
    _rules;
    _disabled;
    _condition;
    constructor(rules, disabled, condition) {
        this._rules = rules.filter((rule) => rule._attachOwner(this));
        this._disabled = disabled;
        this._condition = condition;
    }
    get rules() {
        return this._rules;
    }
    get disabled() {
        return this._disabled;
    }
    get condition() {
        return this._condition;
    }
    *children() {
        yield* this._rules;
    }
    *descendants() {
        for (const child of this.children()) {
            yield child;
            yield* child.descendants();
        }
    }
    equals(value) {
        return (value instanceof Sheet &&
            value._disabled === this._disabled &&
            value._condition.equals(this._condition) &&
            value._rules.length === this._rules.length &&
            value._rules.every((rule, i) => rule.equals(this._rules[i])));
    }
    toJSON() {
        return {
            rules: [...this._rules].map((rule) => rule.toJSON()),
            disabled: this._disabled,
            condition: this._condition.getOr(null),
        };
    }
    toString() {
        return this._rules.join("\n");
    }
}
/**
 * @public
 */
(function (Sheet) {
    function from(json) {
        return Sheet.of(json.rules.map(Rule.from), json.disabled, Option.from(json.condition));
    }
    Sheet.from = from;
})(Sheet || (Sheet = {}));
//# sourceMappingURL=sheet.js.map